export { default as PickUpLocation } from './PickUpLocation';
